// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"d6fb6e39","453":"65ec0eae","455":"98929d0b"}[chunkId] + ".chunk.js";
};